export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5553.9973ddc6.jpg";